import { Container } from "@mantine/core";
import type { CustomLayout } from "next";
import { Header } from "src/layout/AppLayout/Header";
import { PageMain } from "src/layout/AppLayout/PageMain";

import styles from "../AppLayout/AppLayout.module.scss";
import { LayoutErrorBoundary } from "../LayoutErrorBoundary";

export const NoneFooterMenuLayout: CustomLayout = (page) => {
  return (
    <div className={styles.layout}>
      <Header />
      <LayoutErrorBoundary>
        <Container className={styles.inner}>
          <PageMain page={page} />
        </Container>
      </LayoutErrorBoundary>
    </div>
  );
};
